import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Latvian } from "flatpickr/dist/l10n/lv.js"

export default class extends Controller {
  static values = {
    enableTime: { type: Boolean, default: false },
    noCalendar: { type: Boolean, default: false },
    time24hr: { type: Boolean, default: true },
    altInput: { type: Boolean, default: false },
    altFormat: { type: String, default: "" },
    minuteIncrement: { type: Number, default: 5 },
    locale: { type: String, default: "default" },
    dateFormat: { type: String, default: "Y-m-d" }
  }

  connect() {
    flatpickr.l10ns.default.firstDayOfWeek = 1;

    this.picker = flatpickr(this.element, {
      locale: this.localeValue === "lv" ? Latvian : "default",
      enableTime: this.enableTimeValue,
      noCalendar: this.noCalendarValue,
      dateFormat: this.dateFormatValue,
      altInput: this.altInputValue,
      altFormat: this.altFormatValue || this.dateFormatValue,
      allowInput: true,
      time_24hr: this.time24hrValue,
      minuteIncrement: this.minuteIncrementValue,
      disableMobile: true,
      onReady: (_selectedDates, _dateString, instance) => {
        if (!instance.altInput) return

        instance.altInput.setAttribute("aria-label", this.element.getAttribute("aria-label") || "")
      }
    })

    this.openPicker = this.openPicker.bind(this)
    this.trigger = this.element.closest(".date-picker-field")?.querySelector("[data-date-picker-trigger]")
    this.trigger?.addEventListener("click", this.openPicker)
  }

  disconnect() {
    this.trigger?.removeEventListener("click", this.openPicker)
    this.picker?.destroy()
  }

  openPicker() {
    this.picker?.open()
    this.element.focus()
  }
}
